export const locale = {
	lang: 'pt_PT',
	data: {
		en_EN: 'EN',
		fr_FR: 'FR',
		es_ES: 'ES',
		pt_PT: 'PT',
		
		welcome: 'Bem-vindo',
		hello: 'Olá',
		insert_email_login: 'Insira o e-mail para fazer login',
		insert_phone_login: 'Insira o número de telefone para fazer login',
		next: 'Seguinte',
		auth_phone: 'Ou autentique-se via telefone',
		auth_email: "Ou autentique-se via e-mail",
		no_account_login: 'Não tem conta?',
		register: 'Registrar',
		entry_catchphrase: 'Não tens trocos? Deixa conosco',
		sign_in: "Iniciar sessão",
		full_name: "Nome completo",
		email: 'Email',
		phone_number: "Número de telemóvel",
		already_have_account: "Já tens conta?",
		confirmation_code_title: 'Código de confirmação',
		confirmation_code_instruction_email: 'Insira o código de confirmação recebido no seu e-mail para fazer login',
		confirmation_code_instruction_phone: 'Insira o código de confirmação recebido por SMS no seu telemóvel para fazer login',
		code_did_not_recieve: 'Não recebeu o código?',
		code_resend: 'Reenviar código',

		code_sent_success_email: 'Código de confirmação enviado para o seu e-mail.',
		code_sent_success_sms: 'Código de confirmação enviado para o seu telemóvel.',
		code_resend_info: 'Código de confirmação reenviado.',
		code_resend_error: 'Ocorreu um erro ao reenviar o código de confirmação. Por favor, tente novamente.',
		code_confirm_no_cred: 'Nenhuma credencial fornecida para confirmação.',
		code_confirm_error: 'Ocorreu um erro ao confirmar o código. Por favor, tente novamente.',
		code_confirm_invalid_error: 'O código inserido está incorreto.',

		login: 'Login',
		not_received_code: 'Não recebeu o código?',
		resend_code: 'Enviar novamente',
		or_authenticate: 'Ou autentique-se',
		via_phone: 'via telefone',
		via_email: "via e-mail",
		confirm: "Confirmar",
		invalid_field: "Campo inválido",
		field_required: "Este campo é obrigatório",
		field_too_short: "Campo muito curto",
		field_too_long: "Campo muito longo",
		field_invalid_email: "Formato de e-mail inválido",
		field_invalid_phone: "Formato de número de telefone inválido",
		with_another_method: "com outro método",
		wrong_code: "O código inserido está incorreto",
		remaining_attempt: 'Tentativas restantes: ',

		movements: 'Movimentos',
		use_balance: 'Usar',
		back_to_top: 'Voltar ao topo',
		
		login_error: 'Falha no login. Por favor, tente novamente.',
		login_invalid_error: 'Credenciais de login inválidas. Por favor, verifique as suas informações.',
		login_user_not_found_error: 'Usuário não encontrado. Por favor, verifique as suas informações.',
		signup_error: 'Falha no registo. Por favor, tente novamente.',
		signup_user_already_exists_error: 'Número de telefone já existe. Por favor, use um número diferente ou faça login.',
		signup_invalid_error: 'Dados de registo inválidos. Por favor, verifique as suas informações.',

		location_not_authorized_warning: 'Acesso à localização não autorizado. Por favor, ative as permissões de localização para encontrar pontos de venda próximos.',

		points_of_sale_error: 'Falha ao carregar pontos de venda próximos. Por favor, tente novamente.',
		
		session_expired_error: 'Sessão expirada. Por favor, faça login novamente.',

		no_options_select: 'Sem opções disponíveis',
		select_country: 'Selecionar país',

		page_not_found: 'Página não encontrada',
		page_not_found_description: 'A página que procura não existe ou ocorreu outro erro. Volte atrás ou regresse à página inicial clicando no botão abaixo.',
		return: 'Regressar',

		balance: 'Saldo',
		add_balance: 'Adicionar saldo',
		add_card: 'Adicionar cartão',

		read_qr_code: 'Ler código QR',
		read_qr_code_instructions: 'Apróxima o teu smartphone da máquina para ler o código QR.',
		add_physical_card: 'Cartão físico',
		pass_card: 'Passar cartão',
		pass_card_instructions: 'Passa o teu cartão físico no leitor da máquina para prosseguir.',
		confirm_card: 'Confirmar cartão',
		confirm_card_instructions: 'Passe novamente o cartão no leitor da máquina para confirmar os teus dados.',
		finish_card: 'Cartão Adicionado',
		add_another_card: 'Adicionar outro cartão',
		finish: 'Concluído',
		finish_card_instructions: 'O teu cartão foi adicionado com sucesso à tua carteira digital.',
		cancel: 'Cancelar',

		subdomain_not_found: 'Nenhum subdomínio encontrado ou subdomínio inválido',
		subdomain_not_found_description: 'Não foi possível encontrar um subdomínio válido, o URL inserido deve conter um subdomínio válido.',
		balance_use: 'Utilizar saldo',
		balance_use_page_title: 'Defina o valor a ser utilizado',
		available_balance: 'Saldo Disponível',
		approve_use: 'Aprove para prosseguir com a operação',
		add_to_machine: 'Adicionar crédito',

		amount_too_low: 'O montante inserido é demasiado baixo',
		amount_too_high: 'O montante inserido é demasiado alto',

		identify_machine: 'Identificar Máquina',
		scan_qr_code: 'Ler Código QR',
		machine_code: 'Código da Máquina',
		insert_code: 'Inserir Código',
		
		toast_error_invalid_machine: 'O código da máquina é inválido ou o cartão selecionado não pode ser utilizado na máquina.',

		credit_sent: 'Crédito enviado',
		transaction_approved: 'Transação aprovada',
		go_to_home: 'Página Inicial',

		toast_error_transaction_get_error: 'Ocorreu um erro ao obter as transações.',

		add_card_description: 'Que tipo de cartão gostaria de adicionar?',
		add_virtual_card: 'Cartão virtual',
		
		scan_qrcode: 'Ler Código QR',
		error_no_camera_found: 'Nenhuma câmara encontrada. Certifique-se de que o seu dispositivo tem uma câmara e que as permissões necessárias estão concedidas.',
		toast_info_camera_permission_required: 'É necessária permissão da câmara para ler códigos QR. Por favor, ative o acesso à câmara nas definições do seu dispositivo.',
		toast_error_no_camera_found: 'Nenhuma câmara encontrada. Certifique-se de que o seu dispositivo tem uma câmara e que as permissões necessárias estão concedidas.',
		
		toast_error_verifying_card: 'Ocorreu um erro ao verificar o cartão.',
		toast_error_scanning_card: 'Ocorreu um erro ao ler o cartão. Por favor, tente novamente.',

		go_to_cards: 'Ir para os meus cartões',

		or_insert_code: 'ou insira o código',

		promos: 'Regras',
		promo: 'Regra',

		toast_error_fetching_cards: 'Ocorreu um erro ao recuperar os seus cartões.',
		
		sign_out: 'Terminar sessão',
		dialog_signout: 'Pretende terminar sessão na sua conta?',
		
		toast_pwa_get_error: 'Ocorreu um erro ao obter a carteira.',
		home_find_wallet: 'Encontre a sua Carteira de Fidelização',
		loyalty_wallet_recents: 'Carteiras de Fidelização Recentes',
		home_insert_code: 'Inserir código',
		or: 'ou',

		toast_error_getting_pwas: 'Ocorreu um erro ao recuperar as suas carteiras mais recentes.',

		select_recent_machines: 'Selecione máquinas recentes',

		forgot_password: 'Esqueceu-se da palavra-passe?',
		email_input: 'Email',
		password_input: 'Palavra-passe',
		login_wallet: 'Iniciar sessão',
		login_wallet_description: 'Introduza o seu email e palavra-passe para usar a sua Wallet',
		login_button: 'Iniciar sessão',
		login_no_account: 'Não tem conta?',
		login_register: 'Criar uma conta',
		confirm_password_input: 'Confirmar palavra-passe',
		signup_wallet_already_have_account: 'Já tem uma conta?',
		signup_login: 'Iniciar sessão',
		signup_wallet: 'Registar',
		signup_wallet_description: 'Crie a sua conta.',
		signup_button: 'Registar',
		reset_password: 'Palavra-passe',
		reset_password_description: 'Redefina a sua palavra-passe introduzindo o seu email',
		reset_password_button: 'Redefinir palavra-passe',
		reset_login: 'Iniciar sessão',
		reset_password_verified_email: 'Se o seu email estiver registado, irá receber um email para redefinir a sua palavra-passe.',

		toast_signup_email_sent: 'Foi enviado um email para verificar a sua conta.',
		toast_success_reset_password: 'Se tiver uma conta, enviámos-lhe um email com mais instruções.',

		error_email_invalid: 'O email é inválido.',
		error_email_required: 'O email é obrigatório.',

		error_password_required: 'A palavra-passe é obrigatória.',
		error_password_too_short: 'A palavra-passe é demasiado curta.',
		error_password_mismatch: 'As palavras-passe devem coincidir.',

		toast_error_login_invalid: 'Email ou palavra-passe inválidos.',

		server_unreachable: 'Não foi possível contactar o servidor. Por favor, verifique a sua ligação e tente novamente.',
	},
};